<template>
    <div class="body">
        <p class="font1" style="padding-top: 8vh;">
            📚 书籍是通向智慧的钥匙，让我们在知识的海洋中遨游，发现更好的自己！
        </p>
    
        <div class="wrapper">
            <div v-for="(book, index) in books" :key="index" class="book-card">
                <div class="inline-row">
                    <input type="checkbox" :value="book.title" v-model="selectedCourses" />
                    <strong>{{ book.title }}</strong>
                </div>
                <div class="book-info">
                    <p class="book-author" style="text-align: center;">{{ book.author }}</p>
                    <div class="book-desc" v-html="book.description"></div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      ReportData: {
        type: Object,
        required: false
      },
      selected: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selectedCourses: [],
        books: [
          {
            title: '超越百岁',
            author: '[美] 彼得·阿提亚 ',
            description: `本书以“医学3.0”为框架，将健康管理从“发现疾病——>治疗”前移到“预测——>预防——>延缓”。对于希望将“活的更久”升级为“活得更好”到读者，本书提供清晰、可度量、可复盘的路线图。`,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=54990'
          },
          {
            title: '控糖革命',
            author: '[法] 傑西·安佐斯佩',
            description: `全书分为三大部分——为什么要控糖、出现葡萄糖峰值有哪些危害、轻松控糖的10个小窍门，通过8个章节，系统阐释了如何在不节食、不放弃我们喜爱的食物的情况下，用10个简单而令人惊讶的方法平衡我们的血糖水平，提升和改善我们的健康状况，包括睡眠、情绪、健康、皮肤、体重，甚至减缓衰老。`,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=53931'
          }
        ]
      };
    },
    watch: {
      selectedCourses: {
        deep: true,
        handler(newVal) {
          this.$emit('update:selected', newVal);
        }
      }
    },
    mounted() {
      this.selectedCourses = [...this.selected];
    },
  };
  </script>
  <style scoped>
  .body {
      background: 
      url("../../assets/25October/logo.png") right  top  no-repeat,
      url("../../assets/25October/bg.jpg")  no-repeat;
      background-size:100% 100%,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 96%;
      margin: 0;
      /* text-align: center; */
      font-size: 20px;
      color: #d03327;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #36854f;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .wrapper {
      width: 94%;
      text-align: justify;
      margin: 0 auto;
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  .inline-row {
    display: flex;
    align-items: center;     /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    gap: 8px;                /* 他们之间间距 */
    width: 100%;     
    color: #d03327;  
    padding-top: 10px;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25October/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .font1{
    text-align: center;
  }
  .wrapper {
      width: 80%;
      text-align: justify;
      margin: 0 auto;
      font-size: 18px;
      /* border-radius: 10px; */
      /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  }
}
</style>